"use client";
import * as React from "react";
const SvgLightbulbOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 11 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.143 15.2c0 .44.353.8.786.8H7.07c.433 0 .786-.36.786-.8v-.8H3.143v.8ZM5.5 0C2.467 0 0 2.512 0 5.6c0 1.904.935 3.576 2.357 4.592V12c0 .44.354.8.786.8h4.714c.432 0 .786-.36.786-.8v-1.808A5.627 5.627 0 0 0 11 5.6C11 2.512 8.533 0 5.5 0Zm2.24 8.88-.669.48v1.84H3.93V9.36l-.668-.48A4.019 4.019 0 0 1 1.57 5.6c0-2.208 1.76-4 3.929-4 2.169 0 3.929 1.792 3.929 4a4.019 4.019 0 0 1-1.69 3.28Z" }));
export {
  SvgLightbulbOutlined as default
};
